import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import enBase from "lang/locales/lang.en.json";
import koBase from "lang/locales/lang.ko.json";
import contentEn from "lang/locales/content.en.json";
import contentKo from "lang/locales/content.ko.json";

function deepMerge(a, b) {
  const out = { ...a };
  for (const k of Object.keys(b)) {
    if (
      b[k] &&
      typeof b[k] === "object" &&
      !Array.isArray(b[k]) &&
      out[k] &&
      typeof out[k] === "object" &&
      !Array.isArray(out[k])
    ) {
      out[k] = deepMerge(out[k], b[k]);
    } else {
      out[k] = b[k];
    }
  }
  return out;
}

const en = deepMerge(enBase, contentEn);
const ko = deepMerge(koBase, contentKo);

/**
 * 파일명: i18n.js
 * 작성자: 권도훈
 * 작성일자: 23.04.06
 * 설명: 언어팩
 */
const resource = {
  en: {
    translation: en,
  },
  "en-US": {
    translation: en,
  },
  ko: {
    translation: ko,
  },
};

i18n
  .use(LanguageDetector)
  .use(Backend)
  .use(initReactI18next)
  .init({
    debug: false,
    resources: resource,
    fallbackLng: {
      en: ["en"],
      "en-US": ["en"],
      default: ["ko"],
    },
    keySeparator: ".",
    interpolation: {
      escapeValue: false,
    },
    react: {
      bindI18n: "languageChanged",
      bindI18nStore: "",
      transEmptyNodeValue: "",
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ["br", "strong", "i"],
      useSuspense: false,
    },
  });

export default i18n;
